import { FC, useState, useEffect } from 'react'

import styled from 'styled-components'
import { useDisclosure } from '@mantine/hooks'
import { useForm } from 'react-hook-form'
import { useDebounce } from 'use-debounce'

import { PageTitle } from 'src/Components/PageTitle/index.tsx'
import { SearchBlock } from 'src/Pages/Tools/SearchBlock.tsx'
import {
  AddToolBody,
  useAddToolMutation,
  useGetAllToolsQuery,
} from 'src/Redux/api/toolsApi.ts'
import { AddToolsModal } from 'src/Pages/Tools/AddToolsModal.tsx'
import { ToolsTable } from 'src/Pages/Tools/ToolsTable.tsx'
import { device } from 'src/Helpers/constants.ts'
import { TableHeader } from 'src/Pages/Tools/TableHeader.tsx'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 36px;
  position: relative;
  height: 100%;
  overflow: hidden;
`

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 50px;
  position: static;

  @media ${device.tabletMax} {
    gap: 20px;
    width: 100%;
  }

  div {
    width: 100%;
  }
`

export interface SearchToolFormData {
  searchString: string
}

export const ToolsPage: FC = () => {
  const { control, watch } = useForm<SearchToolFormData>()
  const [pageNumber, setPageNumber] = useState(1)

  const [isAddModalOpened, { open: onOpenAddModal, close: onCloseAddModal }] =
    useDisclosure(false)

  const { searchString } = watch()

  const [debouncedSearchValue] = useDebounce(searchString, 1000)

  useEffect(() => {
    setPageNumber(1)
  }, [debouncedSearchValue])

  const { data: toolsResponse, isLoading } = useGetAllToolsQuery({
    name: debouncedSearchValue,
    page: pageNumber,
  })
  const [addTool] = useAddToolMutation()

  const onAddTool = (tool: AddToolBody): void => {
    addTool(tool).then(() => {
      onCloseAddModal()
    })
  }

  const onLoadMore = (): void => {
    setPageNumber(pageNumber + 1)
  }

  return (
    <>
      <AddToolsModal
        onClose={onCloseAddModal}
        onAddTool={onAddTool}
        isOpened={isAddModalOpened}
      />

      <Container>
        <TitleWrapper>
          <PageTitle>Навесное оборудование</PageTitle>

          <SearchBlock onOpenAddModal={onOpenAddModal} control={control} />
        </TitleWrapper>
        <TableHeader />
        <ToolsTable
          tools={toolsResponse?.data}
          isLoading={isLoading}
          onLoadMore={onLoadMore}
          hasNextPage={toolsResponse?.meta.hasNextPage}
        />
      </Container>
    </>
  )
}
